import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { translations } from "./translations";

const resources = {
  en: { translation: translations.en },
  tr: { translation: translations.tr },
  // Future language placeholders using English keys to prevent missing string crashes
  it: { translation: translations.en },
  de: { translation: translations.en },
  es: { translation: translations.en },
  fr: { translation: translations.en }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "tr", "it", "de", "es", "fr"],
    interpolation: {
      escapeValue: false // React already escapes string renders from XSS
    },
    detection: {
      order: ["path", "navigator", "htmlTag"],
      lookupFromPathIndex: 0 // Checks first segment of path (e.g. /tr/home)
    }
  });

export default i18n;
export type LanguageCode = "en" | "tr" | "it" | "de" | "es" | "fr";
